import Vue from 'vue'
import VueI18n from 'vue-i18n'
import config from '@/config'

Vue.use(VueI18n)

/**
 * Return starting locale
 * Use user's settings from local storage if available
 * If not, try to get it from browser, otherwise we will use default one
 *
 * @returns {String}
 */
function loadStartingLocale () {
  const locale = localStorage.getItem('user_language')

  if (locale) {
    return locale
  }

  // Detect locale from browser
  const navigatorLocale = navigator.languages !== undefined
    ? navigator.languages[0]
    : navigator.language

  if (!navigatorLocale) {
    return config.app_default_locale
  }

  return navigatorLocale.trim().split(/-|_/)[0]
}

/**
 * Load translations from @/lang/ directory
 *
 * @returns {Object}
 */
function loadTranslationMessages () {
  const messages = {};
  const languages = require.context(
    "@/lang",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );

  languages.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)

    if (matched && matched.length > 1) {
      const language = matched[1];
      messages[language] = languages(key)
    }
  })

  return messages;
}

export default new VueI18n({
  locale: loadStartingLocale(),
  fallbackLocale: config.app_default_locale,
  messages: loadTranslationMessages(),
})
